import { lazyRouteComponent } from '@tanstack/react-router';

export const projectPageLoadable = lazyRouteComponent(() =>
  import('../../ui/project-page').then((m) => ({
    default: m.ProjectPage,
  })),
);
